<h2 mat-dialog-title class="dialog-title">
  <mat-icon class="title-icon">content_copy</mat-icon>
  Copy from {{ data.sourceResource.name }}
</h2>
<mat-dialog-content>
  <div class="copy-content-container">
    <!-- Top Row: Availability and Attributes side by side -->
    <div class="top-row">
      <!-- Availability Section -->
      <div class="availability-card">
        <div class="section-header">
          <mat-checkbox [(ngModel)]="copyAvailability" class="section-checkbox">
            <h3 class="section-title-inline">
              <mat-icon class="section-icon">schedule</mat-icon>
              Availability Schedule
            </h3>
          </mat-checkbox>
        </div>

        <div class="section-content" *ngIf="copyAvailability">
          <div class="days-container">
            <mat-checkbox
              *ngFor="let day of days"
              [(ngModel)]="day.selected"
              (change)="updateAvailabilityPreview()"
              class="day-checkbox">
              <span class="day-label">{{ day.day.substring(0, 3) }}</span>
            </mat-checkbox>
          </div>

          <div class="overwrite-option">
            <mat-checkbox [(ngModel)]="overwriteExisting">
              Overschrijf bestaande beschikbaarheid
            </mat-checkbox>
            <p class="overwrite-warning" *ngIf="overwriteExisting">
              <mat-icon class="warning-icon">warning</mat-icon>
              Bestaande beschikbaarheid voor de geselecteerde dagen wordt eerst verwijderd
            </p>
          </div>

          <div class="availability-preview" *ngIf="getFilteredAvailability().length > 0">
            <h4 class="preview-label">Blocks to copy:</h4>
            <app-availability-blocks
              [availability]="getFilteredAvailability()"
              [compact]="false"
              [maxBlocks]="0">
            </app-availability-blocks>
          </div>

          <div class="no-availability-warning" *ngIf="sourceAvailability.length > 0 && getFilteredAvailability().length === 0">
            <mat-icon class="warning-icon">info</mat-icon>
            <span>No availability for selected days</span>
          </div>
        </div>
      </div>

      <!-- Attributes Section -->
      <div class="attributes-card" [class.has-attributes]="availableAttributes.length > 0">
        <div class="section-header">
          <mat-checkbox [(ngModel)]="copyAttributes" [disabled]="availableAttributes.length === 0" class="section-checkbox">
            <h3 class="section-title-inline">
              <mat-icon class="section-icon">list_alt</mat-icon>
              Resource Attributes
            </h3>
          </mat-checkbox>
          <button
            mat-stroked-button
            *ngIf="copyAttributes && availableAttributes.length > 0"
            (click)="toggleAllAttributes(!allAttributesSelected)"
            class="select-all-btn">
            {{ allAttributesSelected ? 'Deselect All' : 'Select All' }}
            ({{ getSelectedAttributeCount() }}/{{ availableAttributes.length }})
          </button>
        </div>

        <div class="section-content" *ngIf="copyAttributes && availableAttributes.length > 0">
          <div class="attributes-grid">
            <div class="attribute-item" *ngFor="let attr of availableAttributes">
              <mat-checkbox
                [(ngModel)]="attr.selected"
                (change)="updateAttributeSelectionState()">
                <div class="attribute-content">
                  <span class="attribute-name">{{ attr.name }}</span>
                  <span class="attribute-value">{{ getAttributeValue(attr) }}</span>
                </div>
              </mat-checkbox>
            </div>
          </div>
        </div>

        <div class="no-attributes-message" *ngIf="availableAttributes.length === 0">
          <mat-icon class="info-icon">info_outline</mat-icon>
          <span>No attributes defined for this resource type</span>
        </div>
      </div>
    </div>

    <!-- Bottom Section: Target Resources (full width) -->
    <div class="resources-card">
      <div class="resources-header">
        <h3 class="section-title">Select Target Resources</h3>
        <button mat-stroked-button (click)="toggleAll(!allSelected)" class="select-all-btn">
          {{ allSelected ? 'Deselect All' : 'Select All' }}
          ({{ getSelectedCount() }}/{{ targetResources.length }})
        </button>
      </div>

      <div class="resources-grid-full" *ngIf="!loading">
        <mat-checkbox
          *ngFor="let resource of targetResources"
          [(ngModel)]="resource.selected"
          (change)="updateSelectionState()"
          class="resource-checkbox-compact">
          <span class="resource-name-compact">{{ resource.name }}</span>
        </mat-checkbox>
      </div>

      <div class="loading-container" *ngIf="loading">
        <mat-progress-spinner
          mode="indeterminate"
          diameter="40">
        </mat-progress-spinner>
        <p>Loading resources...</p>
      </div>

      <div class="summary-section" *ngIf="!loading && getSelectedCount() > 0">
        <mat-divider></mat-divider>
        <div class="summary-content">
          <div class="summary-stats">
            <div class="stat-item">
              <mat-icon class="stat-icon">people</mat-icon>
              <span><strong>{{ getSelectedCount() }}</strong> resources selected</span>
            </div>
            <div class="stat-item" *ngIf="copyAvailability && getFilteredAvailability().length > 0">
              <mat-icon class="stat-icon">schedule</mat-icon>
              <span><strong>{{ getFilteredAvailability().length }}</strong> time slots will be copied</span>
            </div>
            <div class="stat-item" *ngIf="copyAttributes && getSelectedAttributeCount() > 0">
              <mat-icon class="stat-icon">list_alt</mat-icon>
              <span><strong>{{ getSelectedAttributeCount() }}</strong> attributes will be copied</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button
    mat-flat-button
    [color]="canSubmit ? 'primary' : 'warn'"
    [disabled]="copying"
    [class.button-invalid]="!canSubmit"
    (click)="onCopy()">
    <span class="button-content">
      <mat-progress-spinner
        *ngIf="copying"
        mode="indeterminate"
        diameter="18"
        class="button-spinner">
      </mat-progress-spinner>
      <mat-icon *ngIf="!copying">content_copy</mat-icon>
      {{ copying ? 'Copying...' : 'Copy to Selected Resources' }}
    </span>
  </button>
</mat-dialog-actions>